import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import Immutable from 'immutable';
import getTableColumnCountForCells from '../utils/getTableColumnCountForCells';
import getTableRowCountForCells from '../utils/getTableRowCountForCells';
export default function makeGetSelectedTableCells(store) {
  return {
    getSelectedTableCells: function getSelectedTableCells(editor) {
      var tableId = store.getItem('lastFocusedTableId');
      var cells = editor.getTableCells(tableId);
      var tableColumnCount = getTableColumnCountForCells(cells);
      var tableRowCount = getTableRowCountForCells(cells);

      var _ref = store.getItem(tableId) || {},
          selectedCellsCoords = _ref.selectedCellsCoords;

      return (selectedCellsCoords || new Immutable.List()).reduce(function (memo, _ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            rowIndex = _ref3[0],
            columnIndex = _ref3[1];

        if (rowIndex >= tableRowCount || columnIndex >= tableColumnCount) {
          // Cell does not exists anymore
          return memo;
        }

        var cell = cells.get(rowIndex * tableColumnCount + columnIndex);
        return memo.push(cell);
      }, new Immutable.List());
    }
  };
}